/**
 * Página de Solicitação de Criação de Acesso Institucional (RQ36)
 * 
 * Formulário isolado para solicitação rápida de criação de acesso institucional
 */

import React from 'react'
import { TemplateQuickForm } from './TemplateQuickForm'
import { solicitacaoCriacaoAcessoInstitucionalSchema } from '../schemas/RQ36-solicitacaoCriacaoAcessoInstitucional'

const PROCESSO_VINCULADO_ID = 111 // Alterar para o ID do processo

export const SolicitacaoCriacaoAcessoInstitucionalPage: React.FC = () => {
  return (
    <TemplateQuickForm
      templateId="solicitacao_criacao_acesso_institucional"
      templateSchema={solicitacaoCriacaoAcessoInstitucionalSchema}
      processoVinculado={PROCESSO_VINCULADO_ID}
    />
  )
}
